var React = require('react');

function IconClock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 0C8.525 0 0 8.525 0 19s8.525 19 19 19 19-8.525 19-19S29.475 0 19 0zm0 3.167A15.81 15.81 0 0 1 34.833 19 15.81 15.81 0 0 1 19 34.833 15.81 15.81 0 0 1 3.167 19 15.81 15.81 0 0 1 19 3.167zm0 3.167c-.874 0-1.583.709-1.583 1.583V19c0 .874.709 1.583 1.583 1.583h10.028c.874 0 1.583-.709 1.583-1.583s-.709-1.583-1.583-1.583h-8.444v-9.5c0-.874-.709-1.583-1.583-1.583z"}));
}

IconClock.defaultProps = {"width":"38","height":"38","fill":"none"};

module.exports = IconClock;

IconClock.default = IconClock;
